import styled from "styled-components";
import { FontSize } from "@themes/Fonts";

export const LifeAtHeaderPrimary = styled.span`
    color: ${(props) => props.theme.textColorPrimary};
    font-size: ${FontSize.large};
    font-weight: bold;
`;

export const LifeAtBodyPrimary = styled.span`
    color: ${(props) => props.theme.textColorPrimary};
    font-size: ${FontSize.normal};
`;

export const LifeAtBodySecondary = styled.span`
    color: ${(props) => props.theme.textColorSecondary};
    font-size: ${FontSize.small};
`;

export const LifeAtLabelMini = styled.span`
    color: ${(props) => props.theme.textColorSecondary};
    font-size: ${FontSize.mini};
`;

export const LifeAtInputLabel = styled.label`
    color: ${(props) => props.theme.textColorSecondary};
    font-size: ${FontSize.small};
`;
